/**
 * Column width constants for the line items form
 * These widths are used for both the header row and the form fields to ensure proper alignment
 */
export const COLUMN_WIDTHS = {
	/** Width for the quantity input field */
	quantity: 90,
	/** Width for the need by date picker */
	needBy: 160,
	/** Width for the allow substitution toggle */
	allowSubs: 70,
	/** Width for the will call toggle */
	willCall: 70,
	/** Width for the item allocation picker (Stock/Work Order/Invoice) */
	itemIsFor: 220,
	/** Width for the add/edit note button */
	noteButton: 120,
	/** Width for the delete button */
	deleteButton: 40,
} as const
